import { CodedProperty, NamedProperty } from "sprint-common-web";

import { ContentReferenceType } from "../../types/ContentReferenceType";

export interface ContentVersionDetails {
    id: string;
    code: string;
    type: NamedProperty;
    brandings?: CodedProperty[];
    distributor: NamedProperty;
    isTrailer: boolean;
}

export type CreateContentVersionParams = CreateMovieContentVersionParams | CreateTvEpisodeContentVersionParams;

export interface CreateMovieContentVersionParams {
    type: ContentReferenceType.Movie;
    movieId: string;
}

export const ensureCreateMovieContentVersionParams: (
    params: CreateContentVersionParams
) => asserts params is CreateMovieContentVersionParams = (params) => {
    if (params.type !== ContentReferenceType.Movie) {
        throw new Error("Invalid content type for movie version creation");
    }
};

export interface CreateTvEpisodeContentVersionParams {
    type: ContentReferenceType.TvSeries;
    tvSeriesId: string;
    episodeId: string;
}

export const ensureCreateTvEpisodeContentVersionParams: (
    params: CreateContentVersionParams
) => asserts params is CreateTvEpisodeContentVersionParams = (params) => {
    if (params.type !== ContentReferenceType.TvSeries) {
        throw new Error("Invalid content type for tv episode version creation");
    }
};
